<div class="flex justify-end relative items-center">
  <button
    mat-icon-button
    class="flex items-center justify-center"
    (click)="closeDialog()"
  >
    <mat-icon class="text-orange-color text-xl">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div class="bg-[#FBEFEB] p-[15px] rounded-[8px] mb-[20px]">
    <div class="flex justify-center mb-[16px]">
      <img src="assets/images/icons/location.svg" />
    </div>
    <!-- Main message -->
    <div class="text-center">
      <p class="text-[22px] font-semibold text-[#F54720]">
        Not available in {{ capitalizedLocation || "this area" }}
      </p>
      <p class="text-lg font-normal text-blue-theme-color">
        We're sorry! Phlenu currently doesn't operate Interregional deliveries
        to the selected city. Please choose another city or tap below to get
        notified when we expand to your area.
      </p>
    </div>
  </div>

  <!-- Operating cities section -->
  <div class="px-6">
    <h2 class="font-semibold text-base mb-1 text-blue-theme-color">
      Phlenu Currently Operates In:
    </h2>
    <div
      class="text-base font-normal text-black-color leading-relaxed flex gap-[8px] flex-wrap"
    >
      <ng-container
        *ngFor="let destination of webDestinations; let i = index"
        class=""
      >
        <p class="border border-[#E5E7EB] py-[4px] px-[8px] rounded-[16px]">
          {{ destination.destination_name }}
        </p>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>

<!-- Action button -->
<mat-dialog-actions class="mt-2 !pb-5 !px-0 justify-center">
  <div class="action-button-container">
    <button
      class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color rounded-lg"
      (click)="getNotified()"
    >
      Get Notified
    </button>
  </div>
</mat-dialog-actions>
